export default [
  {
    path: '/productdetails',
    name: 'Productdetails',
    meta: { title: "",hideTab:true },
    component: () => import('@/views/productdetails/index.vue'),

  },

]